"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsComponent = exports.TabWithDynamicHeight = exports.TabComponent = void 0;
var tab_1 = require("./tab");
Object.defineProperty(exports, "TabComponent", { enumerable: true, get: function () { return tab_1.TabComponent; } });
var tab_with_dynamic_height_1 = require("./tab-with-dynamic-height");
Object.defineProperty(exports, "TabWithDynamicHeight", { enumerable: true, get: function () { return tab_with_dynamic_height_1.TabWithDynamicHeight; } });
var tabs_1 = require("./tabs");
Object.defineProperty(exports, "TabsComponent", { enumerable: true, get: function () { return tabs_1.TabsComponent; } });
